export class ContentType {
  static readonly CERTIFICATES = 'CoA'
  static readonly CCN = 'CCN'
  static readonly CONTENT = ''
  static readonly FAQ = 'FAQ'
  static readonly JOB = 'JOB'
  static readonly VIDEO = 'Video'
  static readonly DOCUMENT = 'document'
}
